import React from 'react';
import styled from 'styled-components';
import { IconSearch, IconSmart } from '@bynder/icons';
import { token } from '@bynder/design-system';
import { useSearchMode } from '../SpotlightState';

export function SearchIcon() {
	const { isPerformingNLSSearch } = useSearchMode();

	return (
		<StyledSpan>
			{isPerformingNLSSearch ? (
				<IconSmart size="22px" style={ICON_SMART_STYLE} />
			) : (
				<IconSearch size="22px" />
			)}
		</StyledSpan>
	);
}

const StyledSpan = styled.span`
	position: absolute;
	top: 50%;
	left: 0px;
	transform: translateY(-50%);
	padding-left: 10px;
`;

const ICON_SMART_STYLE = {
	backgroundColor: token.purple500,
	color: 'white',
	borderRadius: token.radiusMedium,
	padding: token.spacing1,
};
